import React from 'react';
import BrandedButton, {
  BrandedButtonProps,
} from '../../../../../Buttons/BrandedButton';
import {
  MODAL_FOOTER_BUTTON_SIZE,
  MODAL_FOOTER_PRIMARY_BUTTON_MIN_WIDTH,
} from '../../../Modal';

interface Props extends Omit<BrandedButtonProps, 'size' | 'variant'> {
  variant?: BrandedButtonProps['variant'];
}

const ConfirmButton: React.FC<Props> = ({
  children,
  variant = 'brand-green',
  ...rest
}) => (
  <BrandedButton
    size={MODAL_FOOTER_BUTTON_SIZE}
    style={{ minWidth: MODAL_FOOTER_PRIMARY_BUTTON_MIN_WIDTH }}
    variant={variant}
    {...rest}
  >
    {children}
  </BrandedButton>
);
ConfirmButton.displayName = 'ConfirmButton';

export default ConfirmButton;
